import { render, staticRenderFns } from "./WaitingForCommercialization.vue?vue&type=template&id=6ae39963&"
import script from "./WaitingForCommercialization.vue?vue&type=script&lang=js&"
export * from "./WaitingForCommercialization.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForCommercialization.vue?vue&type=style&index=0&id=6ae39963&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports